import React from "react";

function InputRadio(props) {
  const { title, choices, name, onChange } = props;

  const changeValue = (e) => onChange(Number(e.target.value));

  return (
    <div className="mm-form__item">
      <div className="form__item-title form__item-input-radio-title">
        {title}
      </div>
      {choices.map((item, i) => (
        <label className="form__item-input-radio-item" key={item.value}>
          <input
            type="radio"
            name={name}
            className="form__item-input-radio"
            onChange={changeValue}
            value={item.value}
          />
          <div className="form__item-input-radio-circle"></div>
          <div className="form__item-input-radio-text">{item.title}</div>
        </label>
      ))}
    </div>
  );
}

export default InputRadio;
